
import { instance } from './index';
import { useQuery, useMutation, useQueryClient } from 'react-query';
import { MODAL_QUERY_NM } from './modal';
import { authExpired, getLocalStorage,  } from './auth';

const contextPath = '/project';
const queryName = 'PROJECT_SURVEY';

export const useGetProjectSurveyList = (pid) => {
    const queryClient = useQueryClient();
    const authInfo = getLocalStorage();
    return useQuery(
                [`${queryName}_LIST`], 
                () => getProjectSurveyList(pid, authInfo && authInfo.accessToken),
                {
                    onError:(err)=> err.response.status===401 && authExpired(queryClient)
                }
                );
}

const getProjectSurveyList = async (pid, accessToken) => {

    if(pid && pid!==null){
        const url = contextPath+'/surveyList/'+pid;
        const retVal = await instance.get(url, {headers:{Authorization:`Bearer ${accessToken}`}})
                                        .then((res)=>{
                                            return res.data;
                                        })

        return retVal;
    }
}

export const useGetProjectSurveyTimesetList = (sid) => {
    const queryClient = useQueryClient();
    const authInfo = getLocalStorage();
    return useQuery(
                [`${queryName}_TIME_LIST`], 
                () => getProjectSurveyTimesetList(sid, authInfo && authInfo.accessToken),
                {
                    onError:(err)=> err.response.status===401 && authExpired(queryClient)
                }
                );
}

const getProjectSurveyTimesetList = async (sid, accessToken) => {

    if(sid && sid!==null){
        const url = contextPath+'/surveyTimesetList/'+sid;
        const retVal = await instance.get(url, {headers:{Authorization:`Bearer ${accessToken}`}})
                                        .then((res)=>{
                                            return res.data;
                                        })

        return retVal;
    }
}

export const useGetSurveyCodeList = () => {
    const queryClient = useQueryClient();
    return useQuery(
                [`${queryName}_SURVEY_CODE_LIST`], 
                () => getSurveyCodeList(),
                {
                    onError:(err)=> err.response.status===401 && authExpired(queryClient)
                }
                );
}

const getSurveyCodeList = async () => {
    const url = contextPath+'/utils/getSurveyCodeList';

    const retVal = await instance.get(url, null)
                                    .then((res)=>{
                                        return res.data;
                                    })

    return retVal;
}

export const useSetProjectSurvey = () => {
    const queryClient = useQueryClient();
    const authInfo = getLocalStorage();
    return useMutation(
        (sendParam) => {
            switch(sendParam.mode){
                case 'POST':
                case 'PUT':
                    return putProjectSurvey(sendParam, authInfo ? authInfo.accessToken:'');
                case 'DELETE':
                    return deleteProjectSurvey(sendParam, authInfo ? authInfo.accessToken:'');
                default :
                    return putProjectSurvey(sendParam, authInfo ? authInfo.accessToken:'');
            }
        },
        {
            onSuccess:()=>{
                queryClient.invalidateQueries([`${queryName}_LIST`], { refetchInactive: true })
            },
            onError:(err)=>{
                err.response.status===401 ? authExpired(queryClient)
                    : queryClient.setQueryData([MODAL_QUERY_NM],{show:true,msg:err.response.data.message})
            }
        }
    )
}

const putProjectSurvey = async (param, accessToken) => {

    const sendParam = {
        sid: param.sid,
        pid: param.pid,
        snm: param.snm,
        sur_tp: param.sur_tp,
        ccid: param.ccid,
        time_unit: param.time_unit,
        descr: param.descr,
        is_run: param.is_run,
    }

    const retVal = await instance.post(contextPath+'/survey', sendParam,{headers:{Authorization:`Bearer ${accessToken}`}})
                                    .then((res)=>{
                                        return res;
                                    })
    return retVal;

}

const deleteProjectSurvey = async (param, accessToken) => {
    const retVal = await instance.delete(contextPath+'/survey/'+param.sid,{headers:{Authorization:`Bearer ${accessToken}`}})
                                    .then((res)=>{
                                        return res;
                                    })
    return retVal;

}

export const useSetProjectSurveyTimeTable = () => {
    const queryClient = useQueryClient();
    const authInfo = getLocalStorage();
    return useMutation(
        (sendParam) => {
            switch(sendParam.mode){
                case 'POST':
                    return postProjectSurveyTimeTable(sendParam, authInfo ? authInfo.accessToken:'');
                case 'PUT':
                    return putProjectSurveyTimeTable(sendParam, authInfo ? authInfo.accessToken:'');
                case 'DELETE':
                    return deleteProjectSurveyTimeTable(sendParam, authInfo ? authInfo.accessToken:'');
                default :
                    return putProjectSurveyTimeTable(sendParam, authInfo ? authInfo.accessToken:'');
            }
        },
        {
            onSuccess:()=>{
                queryClient.invalidateQueries([`${queryName}_TIME_LIST`], { refetchInactive: true })
            },
            onError:(err)=>{
                err.response.status===401 ? authExpired(queryClient)
                    : queryClient.setQueryData([MODAL_QUERY_NM],{show:true,msg:err.response.data.message})
            }
        }
    )
}

const postProjectSurveyTimeTable = async (param, accessToken) => {

    const sendParam = {
        sid: param.sid,
        sdate: param.sdate,
        stime: param.stime,
        etime: param.etime,
    }

    const retVal = await instance.post(contextPath+'/surveyTimeTable', sendParam,{headers:{Authorization:`Bearer ${accessToken}`}})
                                    .then((res)=>{
                                        return res;
                                    })
    return retVal;

}

const putProjectSurveyTimeTable = async (param, accessToken) => {

    const sendParam = {
        seq: param.seq,
        sdate: param.sdate,
        stime: param.stime,
        etime: param.etime,
    }

    const retVal = await instance.put(contextPath+'/surveyTimeTable', sendParam,{headers:{Authorization:`Bearer ${accessToken}`}})
                                    .then((res)=>{
                                        return res;
                                    })
    return retVal;

}

const deleteProjectSurveyTimeTable = async (param, accessToken) => {

    const retVal = await instance.delete(contextPath+'/surveyTimeTable/'+param.seq, {headers:{Authorization:`Bearer ${accessToken}`}})
                                    .then((res)=>{
                                        return res;
                                    })
    return retVal;

}